// Official-style App Store + Google Play download badges.
// Region-neutral Apple link redirects each visitor to their local store.
export const APP_STORE_URL = "https://apps.apple.com/app/id6760904836";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.solidnl.app";

function AppStoreBadge({ className = "" }) {
  return (
    <svg
      viewBox="0 0 120 40"
      className={className}
      role="img"
      aria-label="Download on the App Store"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="119"
        height="39"
        rx="8"
        fill="#000000"
        stroke="#A6A6A6"
        strokeWidth="1"
      />
      {/* Apple logo */}
      <g transform="translate(13,9) scale(0.022)" fill="#FFFFFF">
        <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57-155.5-127C46.7 790.7 0 663 0 541.8c0-194.4 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.2z" />
      </g>
      <text
        x="34"
        y="16"
        fill="#FFFFFF"
        fontFamily="-apple-system, Helvetica, Arial, sans-serif"
        fontSize="7"
      >
        Download on the
      </text>
      <text
        x="34"
        y="30"
        fill="#FFFFFF"
        fontFamily="-apple-system, Helvetica, Arial, sans-serif"
        fontSize="16"
        fontWeight="600"
      >
        App Store
      </text>
    </svg>
  );
}

function GooglePlayBadge({ className = "" }) {
  return (
    <svg
      viewBox="0 0 135 40"
      className={className}
      role="img"
      aria-label="Get it on Google Play"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="134"
        height="39"
        rx="8"
        fill="#000000"
        stroke="#A6A6A6"
        strokeWidth="1"
      />
      {/* Play triangle */}
      <g transform="translate(11,10) scale(0.74)">
        <polygon points="0,0 7,12 0,12" fill="#00A0FF" />
        <polygon points="0,12 7,12 0,24" fill="#00E676" />
        <polygon points="0,0 21,12 7,12" fill="#FF3B30" />
        <polygon points="0,24 7,12 21,12" fill="#FFCE00" />
      </g>
      <text
        x="34"
        y="16"
        fill="#FFFFFF"
        fontFamily="Roboto, Arial, sans-serif"
        fontSize="6.5"
        letterSpacing="0.5"
      >
        GET IT ON
      </text>
      <text
        x="34"
        y="30"
        fill="#FFFFFF"
        fontFamily="Roboto, Arial, sans-serif"
        fontSize="15"
        fontWeight="500"
      >
        Google Play
      </text>
    </svg>
  );
}

function StoreBadges({ className = "", badgeClassName = "h-14 w-auto" }) {
  return (
    <div
      className={`flex flex-col sm:flex-row items-center gap-4 ${className}`}
    >
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download SOLID on the App Store"
        className="transition-transform hover:scale-105 active:scale-95"
      >
        <AppStoreBadge className={badgeClassName} />
      </a>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get SOLID on Google Play"
        className="transition-transform hover:scale-105 active:scale-95"
      >
        <GooglePlayBadge className={badgeClassName} />
      </a>
    </div>
  );
}

export default StoreBadges;
